import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * Clima nav: composición tipo collage (WbSunny + AcUnit) en diagonal.
 * Solo glifos monocromáticos (currentColor) — sin paneles de fondo.
 * Blanco inactivo / azul activo vía BottomNavIcon.
 *
 * Revert (estado previo a agrandar sol/nieve):
 *   sol:  translate(0.15 0.15) scale(0.5)
 *   nieve: translate(11.7 11.7) scale(0.5)
 *   diagonal: sin cambios (M2.5 21.5 L21.5 2.5, strokeWidth 0.85)
 */
const ClimateSunSnowIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Diagonal fina (como en el collage, sin tapar sol/copo) */}
    <path
      d="M2.5 21.5 L21.5 2.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={0.85}
      strokeLinecap="round"
    />

    {/* Sol — path Material WbSunny, arriba-izquierda (un poco más grande + hacia afuera) */}
    <g transform="translate(-0.55 -0.55) scale(0.55)">
      <path
        fill="currentColor"
        d="m6.76 4.84-1.8-1.79-1.41 1.41 1.79 1.79zM4 10.5H1v2h3zm9-9.95h-2V3.5h2zm7.45 3.91-1.41-1.41-1.79 1.79 1.41 1.41zm-3.21 13.7 1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5v2h3v-2zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6m-1 16.95h2V19.5h-2zm-7.45-3.91 1.41 1.41 1.79-1.8-1.41-1.41z"
      />
    </g>

    {/* Copo — path Material AcUnit, abajo-derecha (un poco más grande + hacia afuera) */}
    <g transform="translate(12.35 12.35) scale(0.55)">
      <path
        fill="currentColor"
        d="M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
      />
    </g>
  </SvgIcon>
);

export default ClimateSunSnowIcon;
